import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../css/featureDetail.css";

const AboutPanIndia = () => (
  <>
    <Helmet>
      <title>Pan India Coverage — Salary Loans Across 28 States | Salary Uncle</title>
      <meta name="description" content="Salary Uncle serves salaried professionals across 28 states & 6 union territories in India. Available in 600+ cities." />
    </Helmet>

    <section className="fd-hero">
      <div className="fd-hero-inner">
        <Link to="/about-us" className="fd-back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Back to About
        </Link>
        <div className="fd-hero-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
            <circle cx="12" cy="9" r="2.5"/>
          </svg>
        </div>
        <span className="fd-tag">PAN INDIA COVERAGE</span>
        <h1>Available in 28 States</h1>
        <p>From Mumbai to Guwahati, Delhi to Bengaluru — instant credit at your fingertips, wherever you work in India.</p>
      </div>
    </section>

    <section className="fd-body">
      <div className="fd-body-inner">
        <div className="fd-highlights">
          {[
            { title: "28 States & 6 UTs", desc: "Service across all 28 states and 6 union territories of India — truly nationwide coverage." },
            { title: "600+ Cities", desc: "From metros to tier-3 cities — we are available in 600+ cities and growing every month." },
            { title: "All Major Banks", desc: "Direct bank transfer to all major Indian banks — SBI, HDFC, ICICI, Axis, PNB & many more." },
            { title: "Multi-Language Support", desc: "Customer support available in English, Hindi, and regional languages for accessibility." },
            { title: "UPI Repayment", desc: "Repay from anywhere using UPI, net banking, or auto-debit — no branch visits ever needed." },
            { title: "Equal Service Quality", desc: "Same fast approval and support whether you are in a metro or a small town." },
          ].map((h, i) => (
            <div className="fd-highlight-card" key={i}>
              <div className="fd-hl-num">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="fd-hl-title">{h.title}</div>
                <div className="fd-hl-desc">{h.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="fd-steps-box">
          <h2>Wherever You Work, We Reach You</h2>
          <div className="fd-steps">
            {[
              { step: "1", text: "Apply from any city — our process is fully online and location-independent." },
              { step: "2", text: "Funds disbursed directly to your bank account anywhere in India." },
              { step: "3", text: "Get support in your preferred language via call, WhatsApp, or email." },
              { step: "4", text: "Repay easily via UPI, net banking, or auto-debit from your local bank." },
              { step: "5", text: "Whether metro or small town — same fast, fair service for everyone." },
            ].map((s, i) => (
              <div className="fd-step-row" key={i}>
                <div className="fd-step-dot">{s.step}</div>
                <div className="fd-step-text">{s.text}</div>
              </div>
            ))}
          </div>
          <Link to="/apply-now" className="fd-cta-btn">Apply Now</Link>
        </div>
      </div>
    </section>
  </>
);

export default AboutPanIndia;
